<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        07.15
        <br />2016
      </span>
      <span class="tiel">美菜成立两年涉足公益领域：最美菜公益基金帮扶农产品供应链上弱势群体</span>
    </div>
    <div class="mat-content">
      <p >
        <img
          src="https://img-oss.yunshanmeicai.com/cfile/43067866fc7f8e4fb1048daf5c183378.jpg"
          width="640"
        />
      </p>
      <div
        class="tet-js"
      >7月15日，美菜网与中国红十字基金会共同发起的最美菜公益基金在京正式成立。该基金首个公益项目“小候鸟关爱计划”正式开展暑期志愿服务。小候鸟关爱计划获得中国红十字基金会、共青团北京市委员会等机构的大力支持。值得注意的是，美菜值两周年之际成立最美菜公益基金，成为农业生鲜电商涉足公益领域的践行者。</div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>最美菜公益基金关注农产品供应链上的弱势群体
      </div>
      <div class="tet-js">
        最美菜公益基金由中国红十字基金会和美菜网共同发起，旨在帮助农产品供应链中的易受损人群，关注他们的生命安全与生计发展。
        <br />
        <br />按照基金的宗旨，最美菜公益基金将开展多项公益活动，其中包括：结合国家精准扶贫政策，为农户提供农业生计发展帮扶，改善农产品产地的生计硬件建设；为农户、餐饮行业经营者、物流司机提供生命安全帮扶，包括为他们提供应急救护及逃生避险技能培训，提高他们自救互救的能力；为因遭受自然灾害或事故而蒙受经济损失的农户、餐饮行业经营者、物流司机提供爱心帮助金；以及经最美菜基金管委会通过的其他公益活动。
        <br />
        <br />最美菜公益基金开展的公益活动实际上围绕着美菜网的业务链条开展，美菜网是中国领先的农产品移动电商平台，其业务模式是，帮助全国近千万家餐厅做采购，缩短农产品流通环节，降低商户供应链成本，减少供应链人力。其一直致力于用前卫的理念和先进的科技改变落后的中国农业市场。
        <br />
        <br />
在美菜模式改变着中国农业市场的同时，最美菜公益开始对农产品供应链上弱势群体进行关怀和帮扶。
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>关爱百名小候鸟暑期志愿服务正式开启
      </div>
      <div class="tet-js">
        最美菜基金从2016年5月底开始筹办，期间已于7月初开展首个公益项目——“小候鸟关爱计划”，其旨在关注留守儿童及流动未成年人的生存状况，通过关怀帮扶及志愿活动，“小候鸟”感受爱的温度。7月3日，“最美菜公益基金——小候鸟关爱计划”在山东省德州市夏津县蔡庄小学援建首个“最美教室”，通过捐建视频教室，实现父母对“小候鸟”的“空中陪伴”。
        <br />
        <br />为进一步呼吁社会关注“小候鸟”这一群体，7月15日，最美菜公益基金正式启动2016年暑期关爱计划，时间为7-8月，寻找和征集一百名来京探望打工父母的“小候鸟”，对他们的生活关怀帮扶，同时，招募志愿者开展关爱活动，并开展“小候鸟关爱计划”的募款活动。
        <br />
        <br />发布仪式中，最美菜公益基金发起方之一中国红十字基金会相关负责人表示，今后，最美菜公益基金将结合国家政策，为孩子们提供更加完善的陪护和帮扶。其次，公益事业需要全社会的共同参与，希望有更多社会力量参与进来，帮扶农村留守儿童使其健康成长。
        <p align="center" style="padding: 40px 0 10px;">
          <img src="https://img-oss.yunshanmeicai.com/cfile/a10bfca81470e064080fffead22da669.jpg" />
        </p>
      </div>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜网CEO谈为何做公益？
      </div>
      <div class="tet-js">
        一家成立才两年的创业公司，为何要做公益？对此，从农村走出来的美菜网CEO刘传军表示，对农村的情感，对土地的热爱，对农民的理解，来源于他的生活经历，并永远烙印在心里。借助互联网的力量，尽可能的改变农村的现状、改善农民的生活，进而推动新时代农业的发展，是刘传军创办美菜的初衷，“也是作为一个农民的儿子的初心”。而在创办美菜两年内，对于农产品供应链上的弱势群体的困苦体会深刻，希望能够通过各种努力，改变现状，让他们燃气对生活更大的希望。因此，美菜初生之时，就带有公益色彩。
        <br />
        <br />同时，针对“要卖多少菜才能赚回做公益的钱”这个问题，刘传军表示，钱虽是做公益的重要条件，但是，价值观远比钱重要，公益要倾注美好的情感等一切因素去激发更多的爱心参与到公益活动中。实际上，美菜成立两年间，在公司内部，在司机团队内部、农村生计源头，一直有自发的公益行动，如星星之火，点亮公益之心。
        <br />
        <br />此外，刘传军还表示，在最美菜公益基金筹备期间，特别是“小候鸟”关爱计划中，已经见证了太多的力量参与其中，包括中国红十字基金会、各级政府、爱心人士和媒体朋友。
        <br />
        <br />此次发布仪式有相关单位领导、媒体记者、小候鸟代表、各支持组织团体及美菜代表等数千人出席，共同见证和参与此次帮扶活动。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>

</style>
